import { EventInformation } from "../../reducers/states/event-management";
import { EventManagementActions as types } from "../types";

export type createEventPayload = Omit<EventInformation, "id" | "lastModifiedBy" | "lastModifiedDate">;
export type updateEventPayload = Omit<EventInformation, "id">;

export const createEventRequest = (payload: createEventPayload) => ({
  type: types.CREATE_EVENT,
  payload: {
    ...payload,
  } as createEventPayload,
});

export const createEventSuccess = (successMessage: string) => ({
  type: types.CREATE_EVENT_SUCCESS,
  payload: { successMessage },
});

export const createEventFailure = (failureMessage: string) => ({
  type: types.CREATE_EVENT_FAILURE,
  payload: { failureMessage },
});

export const createEventFailureAcknowledged = () => ({
  type: types.CREATE_EVENT_FAILURE_ACKNOWLEDGED,
  payload: {},
});

export const deleteEventRequest = (id: string) => ({
  type: types.DELETE_EVENT,
  payload: { id },
});

export const deleteEventSuccess = (id: string, successMessage: string) => ({
  type: types.DELETE_EVENT_SUCCESS,
  payload: { id, successMessage },
});

export const deleteEventFailure = (id: string, failureMessage: string) => ({
  type: types.DELETE_EVENT_FAILURE,
  payload: { id, failureMessage },
});

export const deleteEventFailureAcknowledged = () => ({
  type: types.DELETE_EVENT_FAILURE_ACKNOWLEDGED,
  payload: {},
});

export const getEventsRequest = () => ({
  type: types.GET_EVENTS,
  payload: {},
});

export const getEventsSuccess = (data: EventInformation[]) => ({
  type: types.GET_EVENTS_SUCCESS,
  payload: { data },
});

export const getEventsFailure = (failureMessage: string) => ({
  type: types.GET_EVENTS_FAILURE,
  payload: { failureMessage },
});

export const getEventRequest = (id: string) => ({
  type: types.GET_EVENT,
  payload: { id },
});

export const getEventSuccess = (data: EventInformation) => ({
  type: types.GET_EVENT_SUCCESS,
  payload: { data },
});

export const getEventFailure = (failureMessage: string) => ({
  type: types.GET_EVENT_FAILURE,
  payload: { failureMessage },
});

export const updateEventRequest = (id: string, payload: updateEventPayload) => ({
  type: types.UPDATE_EVENT,
  id, // todo: jcavner: this should be part of the payload? payload could have id, and data??
  payload: {
    ...payload,
  } as updateEventPayload,
});

export const updateEventSuccess = (successMessage: string) => ({
  type: types.UPDATE_EVENT_SUCCESS,
  payload: { successMessage },
});

export const updateEventFailure = (failureMessage: string) => ({
  type: types.UPDATE_EVENT_FAILURE,
  payload: { failureMessage },
});
